import React from 'react';
import headerLetterheadRaw from '../../assets/letterhead/header.svg?raw';
import footerLetterheadRaw from '../../assets/letterhead/Papel Timbrado-2025 - fontes corretas - rodap\u00e9 para pdf - para contrato do site.svg?raw';

/**
 * COMPONENTE: DOCUMENT LETTERHEAD (TEMPLATE MANUAL)
 * Estrutura pronta para Papel Timbrado Vetorial.
 * * INSTRUÇÕES DE MONTAGEM:
 * 1. Este arquivo cria o "papel" A4 invisível (21000 x 29700).
 * 2. Ele posiciona dois containers <svg> internos (Cabeçalho e Rodapé).
 * 3. Você deve colar o conteúdo dos seus arquivos SVG (apenas as tags <g>, <path>, etc.)
 *    nos locais indicados pelos comentários.
 */

const sanitizeSvgInner = (raw) => {
  return String(raw || '')
    .replace(/<\?xml[\s\S]*?\?>/gi, '')
    .replace(/<!DOCTYPE[\s\S]*?>/gi, '')
    .replace(/<!--[\s\S]*?-->/g, '')
    .replace(/^[\s\S]*?<svg[^>]*>/i, '')
    .replace(/<\/svg>[\s\S]*$/i, '')
    .trim();
};

export const DocumentHeader = () => {
  const headerLetterheadInner = sanitizeSvgInner(headerLetterheadRaw);

  return (
    <div className="document-letterhead-header w-full h-full flex items-start justify-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 64.59 28.92"
        style={{ width: '64.59mm', height: '28.92mm', display: 'block' }}
        preserveAspectRatio="xMidYMid meet"
      >
        <g id="Header_Layer" dangerouslySetInnerHTML={{ __html: headerLetterheadInner }} />
      </svg>
    </div>
  );
};

export const DocumentFooter = () => {
  const footerLetterheadInner = sanitizeSvgInner(footerLetterheadRaw);

  return (
    <div className="document-letterhead-footer w-full h-full flex items-end justify-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 170 19.76"
        style={{ width: '170mm', height: '19.76mm', display: 'block' }}
        preserveAspectRatio="xMidYMid meet"
      >
        <g id="Footer_Vectors" dangerouslySetInnerHTML={{ __html: footerLetterheadInner }} />
      </svg>
    </div>
  );
};

const DocumentLetterhead = () => {
  const headerLetterheadInner = sanitizeSvgInner(headerLetterheadRaw);

  const footerLetterheadInner = sanitizeSvgInner(footerLetterheadRaw);

  return (
    <div className="document-letterhead hidden print:block absolute inset-0 w-full h-full pointer-events-none overflow-hidden z-0">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        viewBox="0 0 21000 29700"
        className="w-full h-full"
        shapeRendering="geometricPrecision"
        textRendering="geometricPrecision"
        imageRendering="optimizeQuality"
        fillRule="evenodd"
        clipRule="evenodd"
      >
        {/* =================================================================
            SLOT 1: CABEÇALHO (LOGO + OAB)
            Dimensões do seu SVG: 64.59mm x 18.92mm
            Posição: Centralizado no Topo (Y=1000 para margem de segurança)
            X = (21000 - 6459) / 2 = 7270.5 (Arredondado para 7270)
           ================================================================= */}
        <svg x="7270" y="1000" width="6459" height="2892" viewBox="0 0 64.59 28.92">
          {/* [COLE AQUI O CONTEÚDO INTERNO DO SVG DO CABEÇALHO]
              Cole apenas <g>, <path>, <polygon>, <text> etc.
              Não cole <?xml ...>, <!DOCTYPE ...> nem a tag <svg> externa.
           */}
          <g id="Header_Layer" dangerouslySetInnerHTML={{ __html: headerLetterheadInner }} />
        </svg>

        {/* =================================================================
            SLOT 2: RODAPÉ (BARRA INSTITUCIONAL)
            Dimensões do seu SVG: 170mm x 19.76mm
            Posição: Centralizado na Base (Y=26700)
            X = (21000 - 17000) / 2 = 2000
           ================================================================= */}
        <svg x="2000" y="26700" width="17000" height="1976" viewBox="0 0 170 19.76">
          {/* [COLE AQUI O CONTEÚDO INTERNO DO SVG DO RODAPÉ]
              Cole apenas <g>, <path>, <polygon>, <text> etc.
              Não cole <?xml ...>, <!DOCTYPE ...> nem a tag <svg> externa.

              Se colar atributos no formato SVG/HTML e o JSX reclamar, ajuste:
              - fill-rule -> fillRule
              - stroke-width -> strokeWidth
              - stroke-miterlimit -> strokeMiterlimit
              - clip-rule -> clipRule
              - xml:space -> xmlSpace
           */}
          <g id="Footer_Vectors" dangerouslySetInnerHTML={{ __html: footerLetterheadInner }} />
        </svg>

        <rect fill="none" x="0" y="0" width="21000" height="29700" />
      </svg>
    </div>
  );
};

export default DocumentLetterhead;